export const ANALYTIC_CLICK_EVENT_NAMES = {
  landing: {
    CREATE_ACCOUNT: 'landing-create-account',
    VERIFY_EMAIL: 'landing-verify-email',
    RESEND_CODE: 'landing-resend-code',
    COMPANY_SELECT: 'landing-company-select',
    ACCEPT_TERMS: 'landing-accept-terms',
    BACK_TO_LOGIN: 'landing-back-to-login',
  },
  dashboard: {
    betterDealFoundWidget: {
      SHOW_DEALS: 'better-deal-widget-show-deals',
      SHOW_MORTGAGE_DETAIL: 'better-deal-widget-show-mortgage-detail',
      REQUEST_CALLBACK: 'better-deal-widget-request-callback',
    },
    hasCaseWidget: {
      SHOW_REMORTGAGE_DETAILS: 'has-case-widget-show-remortgage-details',
      SHOW_SMART_SEARCH_DETAILS: 'has-case-widget-show-smart-search-details',
      SHOW_HELP_DETAILS: 'has-case-widget-show-help-details',
    },
    smartSearchWidget: {
      CREATE_SMART_SEARCH: 'smart-search-widget-create-smart-search',
    },
    addLandlordProperty: {
      ADD_PROPERTY: 'add-landlord-property-widget-add-property',
    },
    remortgageGuide: {
      LEARN_MORE: 'remortgage-guide-widget-learn-more',
    },
    epcImprovements: {
      SHOW_EPC_DETAIL: 'epc-improvements-widget-show-epc-detail',
    },
    addSmartSearch: {
      ADD_SMART_SEARCH: 'add-smart-search-widget-add-smart-search',
    },
    minimalClientData: {
      SHOW_PROFILE: 'minimal-client-data-widget-show-profile',
    },
    addProperty: {
      ADD_PROPERTY: 'add-property-widget-add-property',
    },
    addMortgageWidget: {
      ADD_MORTGAGE: 'add-mortgage-widget-add-mortgage',
    },
  },
  betterDealComparison: {
    SNOOZE: 'better-deal-comparison-snooze',
    COMPARE: 'better-deal-comparison-compare',
    REQUEST_CALLBACK: 'better-deal-comparison-request-callback',
    FILTER_DEALS: 'better-deal-comparison-filter-deals',
    SHOW_DEAL_DETAIL: 'better-deal-comparison-show-deal-detail',
    SHOW_PROPERTY_DETAIL: 'better-deal-comparison-show-property-detail',
    SHOW_COMPARISON_SETTINGS: 'better-deal-comparison-show-comparison-settings',
    CHANGE_DEAL: 'better-deal-comparison-change-deal',
  },
  portfolio: {
    ACTION_MENU: 'property-overview-menu',
    SHOW_PROPERTY: 'property-overview-show-property',
    SHOW_MORTGAGE: 'property-overview-show-mortgage',
    SHOW_BETTER_DEAL: 'property-overview-show-better-deal',
    SHOW_CASE: 'property-overview-show-case',
    SHOW_REMORTGAGE_GUIDE: 'property-overview-show-remortgage-guide',
    SHOW_SMART_SEARCH: 'property-overview-show-smart-search',
    SHOW_EPC_DETAIL: 'property-overview-show-epc-detail',
    ADD_MORTGAGE: 'property-overview-add-mortgage',
    ADD_SMART_SEARCH: 'property-overview-add-smart-search',
    ADD_PROPERTY: 'property-overview-add-property',
    ADD_PROPERTY_RESIDENTIAL: 'property-overview-add-property-residential',
    ADD_PROPERTY_BUY_TO_LET: 'property-overview-add-property-buy-to-let',
  },
  propertyDetail: {
    CREATE_MOVE_HOME_SMART_SEARCH: 'property-detail-create-move-home-smart-search',
    SHOW_MORTGAGE: 'property-detail-show-mortgage',
    ADD_VALUATION: 'property-detail-add-valuation',
    SET_VALUATION: 'property-detail-set-valuation',
    DELETE_VALUATION: 'property-detail-delete-valuation',
    SHOW_MORE_VALUATIONS: 'property-detail-show-more-valuations',
    SHOW_LESS_VALUATIONS: 'property-detail-show-less-valuations',
    SOLD_PROPERTY: 'property-detail-sold-property',
  },
  propertyList: {
    OPEN_ADD_ENTITY_ACTION_MENU: 'property-list-open-folder-action-menu',
    OPEN_FOLDER_ACTION_MENU: 'property-list-open-folder-action-menu',
    OPEN_PROPERTY_ACTION_MENU: 'property-list-open-property-action-menu',
    OPEN_SMART_SEARCH_ACTION_MENU: 'property-list-open-smart-search-action-menu',
    SHOW_PROPERTY: 'property-list-show-property',
    SHOW_SMART_SEARCH: 'property-list-smart-search',
  },
  mortgageDetail: {
    ADJUST_BALANCE: 'mortgage-detail-adjust-balance',
    CREATE_BORROW_MORE_SMART_SEARCH: 'mortgage-detail-create-borrow-more-smart-search',
    SHOW_PROPERTY: 'mortgage-detail-show-property',
    ADD_IRREGULAR_PAYMENT: 'mortgage-detail-add-irregular-payment',
    DELETE_IRREGULAR_PAYMENT: 'mortgage-detail-delete-irregular-payment',
    REQUEST_CALLBACK: 'mortgage-detail-request-callback',
    SHOW_MORTGAGE_CASE: 'mortgage-detail-show-mortgage-case',
    SHOW_DEALS: 'mortgage-detail-show-deals',
    RESUME_MORTGAGE_MONITORING: 'mortgage-detail-resume-mortgage-monitoring',
    SHOW_RESUME_MORTGAGE_MONITORING_ENQUIRY: 'mortgage-detail-show-resume-mortgage-monitoring-enquiry',
    PAID_OFF_MORTGAGE: 'mortgage-detail-paid-off-mortgage',
    SWITCHED_MORTGAGE: 'mortgage-detail-switched-mortgage',
    MORTGAGE_HOLIDAY: 'mortgage-detail-mortgage-holiday',
    OVERPAYMENT: 'mortgage-detail-overpayment',
    SOMETHING_ELSE: 'mortgage-detail-something-else',
  },
  navigation: {
    PROFILE: 'navigation-profile',
    ADVISER: 'navigation-adviser',
    DASHBOARD: 'navigation-dashboard',
    PROPERTIES: 'navigation-properties',
    ARTICLES: 'navigation-articles',
    INBOX: 'inbox',
    BACK: 'navigation-back',
  },
  profile: {
    SHOW_NOTIFICATIONS_SETTING: 'profile-show-notifications-setting',
    SHOW_SEARCH_PREFERENCES: 'profile-show-search-preferences',
    SHOW_CREDIT_REPORT: 'profile-show-credit-report',
    SHOW_INCOME: 'profile-show-income',
    SHOW_ACTIONS: 'profile-show-actions',
    SHOW_ADVISOR: 'profile-show-advisor',
    SHOW_COOKIES: 'profile-show-cookies',
    SHOW_DOCUMENTS: 'profile-show-documents',
    LOGOUT: 'profile-logout',
    EDIT_BASIC_INFO: 'profile-edit-basic-info',
    SAVE_BASIC_INFO: 'profile-save-basic-info',
    CANCEL_UPDATE_BASIC_INFO: 'profile-cancel-update-basic-info',
  },
  smartSearch: {
    SHOW_DEAL_DETAIL: 'smart-search-show-deal-detail',
    OPEN_CASE: 'smart-search-open-case',
    SHOW_CASE_DETAIL: 'smart-search-show-case-detail',
    SHOW_MORE_DEALS: 'smart-search-show-more-deals',
    SHOW_PROPERTY_DETAIL: 'smart-search-show-property-detail',
  },
  smartSearchList: {
    SHOW_LIST: 'show-smart-search-list',
    ADD_NEW: 'smart-search-list-add-new',
  },
};
